"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = exports.IMAGE_BASE_URL = void 0;
const react_1 = __importDefault(require("react"));
exports.IMAGE_BASE_URL = 'https://s7d9.scene7.com/is/image/LifeWayChristianResources';
const ABSOLUTE_URL_REGEX = new RegExp('^https?://', 'i');
function Image(props) {
    const { alt, src } = props, rest = __rest(props, ["alt", "src"]);
    let imageUrl = `${exports.IMAGE_BASE_URL}${src}`;
    if (src && ABSOLUTE_URL_REGEX.test(src)) {
        imageUrl = src;
    }
    return react_1.default.createElement("img", Object.assign({ src: imageUrl, alt: alt }, rest));
}
exports.Image = Image;
